
<template>
  <div>
    <div class="container body-content" id="app">
      <app-header v-bind:title="header"></app-header>
      <router-view></router-view>
      <app-footer v-bind:title="footer"></app-footer>
    </div>
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";

export default {
  name: "App",
  components: {
    "app-header": Header,
    "app-footer": Footer,
  },

  data() {
    return {
      header: "Apps Catalog",
      footer: " © Copyright 2021 HP Apps Catalog",
    };
  },
};
</script>

<style>
#app {
  font-family: "FormaDJR";
  text-align: right;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  background-color: #ffffff;
  padding-top: 10px;
  position: relative;
  z-index: 2;
}
.container body-content {
  font-family: "FormaDJR";
}

@font-face {
  font-family: "FormaDJR";
  src: url("~@/assets/fonts/FormaDJRDisplay-Regular.ttf") format("ttf"),
    url("~@/assets/fonts/FormaDJRDisplay-Regular.woff") format("woff"),
    url("~@/assets/fonts/FormaDJRDisplay-Regular.woff2") format("woff2");
  font-weight: 1 900;
  font-style: normal;
}
@font-face {
  font-family: "FormaDJRBold";
  src: url("~@/assets/fonts/FormaDJRDisplay Bold.ttf") format("trueType");
  font-style: bold;
}
</style>
